import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationsComponent } from './notifications.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    NotificationsComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [
    NotificationsComponent
  ]
})
export class NotificationsModule { }
